export default __webpack_public_path__ + "static/media/minisite-pagetype-flipbook.66874cd5.svg";